/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './payment-gateway.reducer';

export const PaymentGatewayDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paymentGatewayEntity = useAppSelector(state => state.paymentGateway.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paymentGatewayDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paymentGateway.detail.title">PaymentGateway</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.id">Id</Translate>
            </span>
          </dt>
          <dd>{paymentGatewayEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.draft">Draft</Translate>
            </span>
            <UncontrolledTooltip target="draft">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.draft" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paymentGatewayEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.paymentGateway.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{paymentGatewayEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/payment-gateway" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/payment-gateway/${paymentGatewayEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PaymentGatewayDetail;
